import { Trans, useTranslation } from 'react-i18next'
import { Box, Stack, Text, TextLink } from '@machobear/design-system'
import { noop } from 'lodash'
import { StripeIcon } from '@/components/icons'

import usePayments from '@/hooks/use-payments'

import SummaryItems from './summary-items'
import SummaryLoading from './summary-loading'
import { contentHeight } from '../paymentStyles.css'
type Props = {
  state: string
  country: string
  isProductLoading?: boolean
  setIsLoading?: () => void
  setLoadingFinished?: () => void
}

const PurchaseSummary = ({
  state,
  country,
  isProductLoading = false,
  setIsLoading = noop,
  setLoadingFinished = noop
}: Props) => {
  const { t } = useTranslation()
  const { loading } = usePayments()

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="full"
      justifyContent="spaceBetween"
      background="neutralLight"
      padding="large"
      className={contentHeight}
    >
      <Stack space="medium">
        <Text size="large" weight="strong">
          {t('l.trust_score.blockpay.purchase_summary.text', 'Purchase Summary')}
        </Text>
        {!loading && !isProductLoading ? (
          <SummaryItems
            state={state}
            country={country}
            setIsLoading={setIsLoading}
            setLoadingFinished={setLoadingFinished}
          />
        ) : (
          <SummaryLoading />
        )}
      </Stack>
      <Box display="flex" justifyContent="spaceBetween" marginTop="xxxlarge">
        <Text tone="tertiary" size="small">
          <Trans i18nKey="l.checkout_modal.purchase_summary.help">
            Got questions?
            <TextLink target="_blank" rel="noopener noreferrer" href="mailto:support@liv.rent">
              Contact us
            </TextLink>
          </Trans>
        </Text>
        <Box display="flex" alignItems="center" justifyContent="center">
          <StripeIcon />
        </Box>
      </Box>
    </Box>
  )
}

export default PurchaseSummary
